import { useCallback, useContext, useEffect } from 'react'
import Add from '@mui/icons-material/Add'
import { GridList, ListPaymentMethods, Logger, Query, Section } from '@wolfdanepug/common-react'
import { useNavigate, useSearchParams } from 'react-router'
import { DEFAULT_REQUEST_HEADERS } from '../../../constants'
import { stripeCallback } from '../../../lib/stripe'
import PaymentMethodCard from '../../../components/payment-method/PaymentMethodCard'
import { PageContext } from '../../../context/page'

export default function PaymentMethods() {
	const navigate = useNavigate()
	const { setPage } = useContext(PageContext)
	const [searchParams] = useSearchParams()

	const handleRedirectRequest = useCallback(async ({ setup_intent, alias, primary }: any) => {
		try {
			await fetch('/api/provider/callback', {
				method: 'POST',
				body: JSON.stringify({
					type: 'setupIntent',
					data: stripeCallback('setupIntent', {
						id: setup_intent,
						alias,
						primary
					})
				}),
				headers: DEFAULT_REQUEST_HEADERS
			})
			navigate('/settings/payment-methods')
		} catch (e) {
			Logger.error(e)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		const status = searchParams.get('redirect_status')
		status === 'succeeded' && handleRedirectRequest(searchParams)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchParams, handleRedirectRequest])

	useEffect(() => {
		setPage({
			title: 'Payment Methods',
			description: 'Manage Your Payment Methods',
			actions: [
				{
					label: 'Add Payment Method',
					link: '/settings/payment-methods/new',
					icon: <Add />
					// enabled: true
				}
			],
			canGoBack: '/settings'
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<Section>
				<Query
					doc={ListPaymentMethods}
					component={GridList}
					componentProps={{
						spacing: 3,
						itemsPerRow: 2,
						component: PaymentMethodCard
					}}
				/>
			</Section>
		</>
	)
}
